import React, { useEffect, useState } from 'react';
import { Button, Image, Layout, message, Modal, Select, Space, Table, Tag, Spin, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { approveFranchiseRequest, deleteFranchaise, getAllFranchaise } from '../../redux/actions/AllActions';
import { Content } from 'antd/es/layout/layout';
import EditFranchise from '../EditFranchise/EditFranchise';
import { Option } from 'antd/es/mentions';
import Filter from '../../components/Filter/Filter';
import Loading from '../../components/Loading/Loading';
import AddFranchise from '../Add/AddFranchise/AddFranchise';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { updateFranchaise } from '../../api/franchise';
import FranchiseDetails from '../../components/Deatails/FranchiseDetails/FranchiseDetails';

const { Header, Footer, Sider } = Layout;

const Franchaise = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.data);

    const [filteredItems, setFilteredItems] = useState([]);
    const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
    const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
    const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [addFranchiseModal, setAddFranchiseModal] = useState(false);
    const [admin, setAdmin] = useState("");

    useEffect(() => {
        const adminData = localStorage.getItem("admindata");
        try {
            const parsedData = JSON.parse(adminData);
            if (parsedData && typeof parsedData === "object") {
                setAdmin(parsedData);
            } else {
                console.error("Invalid admin data structure");
                localStorage.removeItem("admindata");
            }
        } catch (error) {
            console.error("Error parsing admin data:", error);
            localStorage.removeItem("admindata");
        }
    }, []);

    useEffect(() => {
        setFilteredItems(data);
    }, [data]);

    const fetch = () => {
        dispatch(getAllFranchaise());
    }

    useEffect(() => {
        fetch()
    }, [dispatch]);

    const handleChangeStatus = async (e, record) => {
        try {
            const response = await approveFranchiseRequest(e, record?._id)
            dispatch(getAllFranchaise());
            message.success("Status Changed Successfully")
        } catch (e) {
            message.error("Changing Status of Franchise failed")
        }
    }

    const handleEdit = (record) => {
        setEditingRecord(record);
        setIsEditingModelVisible(true);
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this franchise?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                     await (deleteFranchaise(record._id));
                    
                        dispatch(getAllFranchaise());
                        message.success('Franchise deleted successfully');
                  
                } catch (error) {
                    message.error('An error occurred while deleting the franchise');
                }
            },
        });
    };

    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };

    const handleEditCancel = () => {
        setIsEditingModelVisible(false);
    };

    const handleEditApi = async () => {
        const update = await updateFranchaise(editingRecord?._id);
        console.log(update, 'the update is ')
    }

    const columns = [
        {
            title: 'Business Name',
            dataIndex: 'businessName',
            key: 'businessName',
            width: '300px',
        },
        {
            title: "Name ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => (<div>{record?.user?.name}</div>)
        },
        {
            title: "Email ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => (<div>{record?.user?.email}</div>)
        },
        {
            title: 'Gst Number',
            dataIndex: 'gstNumber',
            key: 'gstNumber',
            width: 300,
        },
        {
            title: "Paid",
            dataIndex: 'payment_status',
            key: 'payment_status',
            width: 300,
            render: (_, record) => (
                <Tag color={record?.payment_status === "paid" ? "green" : "red"}>
                    {record?.payment_status === "paid" ? "Paid" : "Not Paid"}
                </Tag>
            )
        },
        {
            title: "Approve",
            dataIndex: 'status',
            key: 'status',
            width: 300,
            render: (_, record) => (
                <Select
                    disabled={record?.payment_status !== 'paid' || record?.status === 'accepted'}
                    style={{ width: "100px" }}
                    onChange={(e) => { handleChangeStatus(e, record) }}
                    value={record.status}>
                    <Option value="pending">Pending</Option>
                    <Option value="rejected">Reject</Option>
                    <Option value="accepted">Accept</Option>
                </Select>
            )
        },
        {
            title: 'Entity Type',
            dataIndex: 'entityType',
            key: 'entityType',
            width: 300,
        },
        {
            title: 'Business Category',
            dataIndex: 'businessCategory',
            key: 'businessCategory',
            width: 300,
        },
        {
            title: 'Business Address',
            dataIndex: 'businessAddress',
            key: 'businessAddress',
            width: 300,
        },
        {
            title: 'Business Overview',
            dataIndex: 'businessOverview',
            key: 'businessOverview',
            width: 300,
        },
        {
            title: 'Business Photo Url',
            dataIndex: 'businessPhotoUrl',
            key: 'businessPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Image src={record?.businessPhotoUrl} width={100} />
            ),
        },
        {
            title: 'Logo Photo Url',
            dataIndex: 'logoPhotoUrl',
            key: 'logoPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Image src={record?.logoPhotoUrl} width={100} />
            ),
        },
        {
            title: 'Franchise Fee',
            dataIndex: 'franchiseFee',
            key: 'franchiseFee',
            width: 300,
        },
        {
            title: 'Royalty Percentage',
            dataIndex: 'royaltyPercentage',
            key: 'royaltyPercentage',
            width: 300,
        },
        {
            title: 'Required Area Sq Ft',
            dataIndex: 'requiredAreaSqFt',
            key: 'requiredAreaSqFt',
            width: 300,
        },
        {
            title: 'Support Provided',
            dataIndex: 'supportProvided',
            key: 'supportProvided',
            width: 300,
        },
        {
            title: 'Territory Availability',
            dataIndex: 'territoryAvailability',
            key: 'territoryAvailability',
            width: 300,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                    <Button type="link" icon={<EyeOutlined />} onClick={() => handleDetails(record)} />
                    <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
                </Space>
            ),
            fixed: 'right'
        },
    ];

    return (
        <Layout style={{ height: '100vh' ,overflow :"hidden"}}>
            <Header style={{ background: '#fff', padding: 0 }}>
                <Row justify="space-between" align="middle" style={{ padding: '0 24px' }}>
                    <Col>
                        <h2>Franchise Management</h2>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={() => setAddFranchiseModal(true)}>
                            + Add Franchise
                        </Button>
                    </Col>
                </Row>
            </Header>
            <Content style={{ margin: '24px 16px 0' }}>
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <>
                        <Filter
                            allData={data}
                            setFilteredItems={setFilteredItems}
                            searchKeys={['gst', 'territoryAvailability', 'businessName']}
                        />
                        <Table
                            columns={columns}
                            dataSource={filteredItems}
                            rowKey={(record) => record._id}
                            pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                            scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                            style={{ marginTop: 16 }}
                        />
                    </>
                )}
            </Content>
            <Modal
                title="Edit Franchise"
                visible={isEditingModelVisible}
                onCancel={handleEditCancel}
                footer={null}
            >
                <EditFranchise
                    handleEditCancel={handleEditCancel}
                    editingRecord={editingRecord} />
            </Modal>
            <Modal
                title="Franchise Details"
                visible={handleDetailsVisible}
                onCancel={() => setHandleDetailsVisible(false)}
                footer={null}
            >
                <FranchiseDetails
                    
                data= {editingRecord}
                
                />
                {/* Add details content here */}
            </Modal>
            <Modal
                title="Add Franchise"
                visible={addFranchiseModal}
                onCancel={() => setAddFranchiseModal(false)}
                footer={null}
            >
                <AddFranchise setAddFranchiseModal={setAddFranchiseModal} />
            </Modal>
        </Layout>
    );
}

export default Franchaise;